import {
  PURCHASE_LOADING,
  GET_PURCHASE,
  GET_PURCHASE_SUCCESS,
  GET_PURCHASE_FAIL,
  ADD_PURCHASE_SUCCESS,
  ADD_PURCHASE_FAIL,
  DELETE_PURCHASE_SUCCESS,
  DELETE_PURCHASE_FAIL,
  UPDATE_PURCHASE_SUCCESS,
  UPDATE_PURCHASE_FAIL,
  PURCHASE_RESET
} from "./actionType";

const INIT_STATE = {
  purchases: [],
  error: {},
};

const Purchase = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PURCHASE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PURCHASE:
          return {
            ...state,
            purchases: action.payload.data,
            isPurchaseCreated: false,
            isPurchaseSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PURCHASE_FAIL:
      switch (action.payload.actionType) {
        case GET_PURCHASE_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isPurchaseCreated: false,
            isPurchaseSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PURCHASE: {
      return {
        ...state,
        isPurchaseCreated: false,
        loading: true,
      };
    }

    case PURCHASE_LOADING: {
      return {
        ...state,
        isPurchaseCreated: false,
        loading: true,
      };
    }

    case ADD_PURCHASE_SUCCESS:
      return {
        ...state,
        isPurchaseCreated: true,
        loading: false,
        purchases: [action.payload.data, ...state.purchases],
      };

    case ADD_PURCHASE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PURCHASE_SUCCESS:
      return {
        ...state,
        loading: false,
        isPurchaseCreated: true,
        purchases: state.purchases.filter(
          purchase => purchase.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PURCHASE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PURCHASE_SUCCESS:
      return {
        ...state,
        loading: false,
        isPurchaseCreated: true,
        purchases: state.purchases.map(purchase =>
          purchase.id.toString() === action.payload.data.id.toString() ? { ...purchase, ...action.payload.data } : purchase
        ),
      };

    case UPDATE_PURCHASE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PURCHASE_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Purchase;